import { render } from "./News.vue?vue&type=template&id=3bdcaf66&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=3bdcaf66&scoped=true&lang=css"
import "../../../../assets/css/news/index.css?vue&type=style&index=1&id=3bdcaf66&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdcaf66"]])

export default __exports__